module.exports = __webpack_public_path__ + "img/logo.a2b8b881.png";